'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isArrayEq = function (arr1, arr2) {
    if (!Array.isArray(arr1) || !Array.isArray(arr2))
        return false;
    if (arr1.length !== arr2.length) {
        return false;
    }
    return arr1.every(function (ele, index) { return arr2[index] === ele; });
};

exports.isArrayEq = isArrayEq;
